import { InsuranceClaimDetailsPage } from './view';

export { default as insuranceClaimDetailsPageReducer } from './reducer';
export { default as insuranceClaimDetailsPageSaga } from './saga';

export default InsuranceClaimDetailsPage;
